/** @format */

import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import useApi from '../hooks/api/Index';
import { error, success } from './Toast';
//add plugin to image upload filePond library
registerPlugin(
	FilePondPluginImagePreview,
	FilePondPluginFileValidateType,
	FilePondPluginFileValidateSize,
);
const FileUploader = ({
	files,
	setFiles,
	allowMultiple = true,
	maxFiles = 3,
	maxFileSize,
	serverUrl,
	method,
	headers = {},
	required = false,
	roles,
	name = null,
}) => {
	return (
		<FilePond
			className='font-family-num-fa f-14'
			files={files}
			onupdatefiles={(fileItems) => {
				setFiles(fileItems);
			}}
			allowMultiple={allowMultiple}
			maxFiles={maxFiles}
			maxFileSize={maxFileSize}
			labelMaxFileSizeExceeded={`باشد (${maxFileSize}) حجم تصویر نباید بیشتر از`}
			name={name === null ? 'photo' : name}
			acceptedFileTypes={roles}
			labelFileTypeNotAllowed={`باشد ${roles.toString()} فرمت فایل باید `}
			server={{
				process: {
					url: serverUrl,
					method: method,
				},
				revert: async (file) => {
					let data = JSON.parse(file);
					await useApi.delete(
						'/event/remove-image',
						{ photo: data.data.path },
						(res) => {
							setFiles([]);
							success('تصویر با موفقیت حذف شد');
						},
						(err) => {
							error('حذف تصویر ناموفق بود');
						},
					);
				},
				headers: headers,
			}}
			labelIdle='<p className="border border-info p-2 font-family-num-fa f-14 text-secondary"><span class="filepond--label-action font-family-num-fa f-14 text-info d-inline-block">انتخاب کنید</span> فایل را اینجا رها کنید و یا</p>'
		/>
	);
};

export default FileUploader;
